import React from 'react';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import Header from '../../components/Header';

const DeleteAccount = () => {
  useDocumentTitle('Delete Account');

  return (
    <div className="inner-wrapper">
      <Header />
      <div className="container">
        <h1 className="site-color-dark-red mb-4">Delete My Account</h1>
        <div className="static-content">
          <p>If you wish to delete your account and all associated data from the Nirakar Satguru app, please follow the instructions below:</p>

          <h2>Account Deletion Request</h2>
          <p>Please send an email to <a href="mailto:info@nirakarsatguru.org">info@nirakarsatguru.org</a> with the subject line <strong>"Delete My Account"</strong>.</p>

          <p>In your email, include the following details:</p>
          <ul>
            <li>Your registered mobile number</li>
            <li>Your full name (optional)</li>
            <li>Any specific data you would like to be removed (if applicable)</li>
          </ul>

          <p>We will process your request within <strong>7 working days</strong> after verifying your identity.</p>

          <h2>Data Retention</h2>
          <p>Once deleted, your account and associated reflections/comments will be permanently removed. Non-personal or anonymized data may be retained for internal analysis, as stated in our privacy policy.</p>

          <h2>Need Help?</h2>
          <p>If you face any issues, please contact our support team at <a href="mailto:support@nirakarsatguru.org">support@nirakarsatguru.org</a>.</p>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
